import { render, staticRenderFns } from "./YdaInputs.vue?vue&type=template&id=e8366b3a&scoped=true"
import script from "./YdaInputs.vue?vue&type=script&lang=js"
export * from "./YdaInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8366b3a",
  null
  
)

export default component.exports